import { Dialog } from '@mui/material';
import { lazy, Suspense, useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { GlobalContext } from '../common/contexts/globalContext';
import { Content } from './Content/Content';
import Sidebar from './Sidebar/Sidebar';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material/';
import Header from './Header/Header';
import ProtectedRoute from '../common/components/ProtectedRoute/ProtectedRoute';
import { theme } from '@cellebrite/saas-ui-common';
import { AuthContext } from 'src/common/contexts/authContext';

const AdminContent = lazy(() => import('./Content/routes/admin/AdminContent'));
const Report = lazy(() => import('./Content/routes/report/Report'));
const DownloadReport = lazy(() => import('./Content/routes/download-report/DownloadReport'));
const Collection = lazy(() => import('./Content/routes/collections/Collection/Collection'));

function App() {
    const { isAuthenticated, isUserAdmin, user } = useContext(AuthContext);
    const { dialog, uiData } = useContext(GlobalContext);
    if (!isAuthenticated) {
        return <></>;
    }
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {isAuthenticated ? (
                <>
                    <Header isUserAdmin={isUserAdmin()} />
                    <Sidebar isUserAdmin={isUserAdmin()} />
                    <Content open={uiData.sidebarIsOpen}>
                        <Suspense fallback={<></>}>
                            <Routes>
                                <Route path={`/collections`} element={<Collection />} />
                                <Route
                                    path={`/admin/*`}
                                    element={
                                        <ProtectedRoute isValid={isUserAdmin()} userId={user.id}>
                                            <AdminContent />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route path={`/report/:streamId`} element={<Report />} />
                                <Route path={`/download-report`} element={<DownloadReport />} />
                                <Route path="/*" element={<Navigate to="/collections" replace />} />
                            </Routes>
                        </Suspense>
                    </Content>
                    <Dialog maxWidth="lg" open={dialog.modal.isOpen}>
                        {dialog.modal.Component}
                    </Dialog>
                </>
            ) : (
                <Navigate to="/login" replace />
            )}
        </ThemeProvider>
    );
}

export default App;
